import PropTypes from 'prop-types';
import Select from '~/js/components/general/Select';

const EventItem = (props) => {
  const {
    images,
    name,
    rates,
    description,
    checked,
    popover,
    validationPopover,
    onSelected,
    onBookNow,
    resortChecked,
    disclaimer ,
  } = props;
  
  let imageElement = <div className="img-placeholder"><span>No image</span></div>;
  let nameFormat = name;

  if (name.indexOf('NEW!') === 0) {
    nameFormat = <span><strong>NEW!</strong> {name.slice(4)}</span>;
  }

  if (images) {
    imageElement = <img src={images.thumbnail || images.normal} alt={name} className="img-responsive" />;
  }

  return (
    <div className="item">
      <div className="item-panel">
        <div className="figure">
          <div className="equal-image">{imageElement}</div>
          <figcaption>{nameFormat}</figcaption>
        </div>
        <p>{description}</p>
        <div className="rates">
          {rates.length &&
            <Select
              data={rates}
              checked={checked}
              placeholder="Select Option"
              onChange={onSelected} />}

          {validationPopover}
        </div>
        <div className="book-now">
          <button
            className="book-btn"
            onClick={() => {
              onBookNow(true);
              window.cmCreateProductviewTag(
                resortChecked + ' : ' + nameFormat,
                resortChecked + ' : ' + nameFormat,
                resortChecked + ' : ' + 'Spa'
              );
            }}>
            Book Now
            <i className="icon-button-next"/>
          </button>

          {popover}
        </div>
      </div>
    </div>
  );
};

EventItem.propTypes = {
  images: PropTypes.object,
  name: PropTypes.string,
  rates: PropTypes.array,
  description: PropTypes.string,
  checked: PropTypes.object,
  popover: PropTypes.object,
  validationPopover: PropTypes.object,
  onSelected: PropTypes.func,
  onBookNow: PropTypes.func
};

EventItem.defaultProps = {
  images: null,
  name: '',
  rates: [],
  description: '',
  checked: {},
  onSelected: () => {},
  onBookNow: () => {}
};

export default EventItem;
